import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { store } from "../redux/store";
import { stopImpersonation } from "../redux/slices/impersonationSlice";
import { setAuth } from "../redux/slices/authSlice";

export default function ImpersonateBanner() {
  const navigate = useNavigate();
  const impersonation = store.getState().impersonation;
  if (!impersonation?.active || !impersonation?.university) return null;

  const handleStop = () => {
    const { previousAuth } = store.getState().impersonation;
    if (previousAuth) store.dispatch(setAuth(previousAuth));
    store.dispatch(stopImpersonation());
    navigate("/universities");
  };

  const name = impersonation.university?.name || impersonation.university?.short_name || "University";

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        py: 1,
        px: 2,
        bgcolor: "warning.main",
        color: "warning.contrastText",
        boxShadow: 1,
      }}
    >
      <Typography variant="body2" fontWeight="medium">
        Impersonating: <strong>{name}</strong>
      </Typography>
      <Button
        size="small"
        variant="outlined"
        onClick={handleStop}
        sx={{
          color: "inherit",
          borderColor: "currentColor",
          "&:hover": { borderColor: "inherit", bgcolor: "rgba(255,255,255,0.15)" },
        }}
      >
        Stop impersonate
      </Button>
    </Box>
  );
}
